import { Link } from 'react-router-dom'
import { Mail, ExternalLink } from 'lucide-react'

const footerLinks = {
  Platform: [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Learn', path: '/learn' },
    { name: 'Crypto', path: '/crypto' },
    { name: 'Contact', path: '/contact' },
  ],
  Resources: [
    { name: 'Technical Analysis', path: '/learn' },
    { name: 'Candlestick Patterns', path: '/learn' },
    { name: 'Market Trends', path: '/learn' },
    { name: 'Risk Management', path: '/learn' },
  ],
  Social: [
    { name: 'YouTube', url: 'https://www.youtube.com/@fivetrader', icon: 'youtube' },
    { name: 'Instagram', url: 'https://www.instagram.com/fivetraderz/', icon: 'instagram' },
    { name: 'Telegram', url: 'https://t.me/+lJRKb2LzvTwxMTZl', icon: 'telegram' },
  ],
}

export default function Footer() {
  return (
    <footer className="relative border-t border-[var(--border-color)] bg-[var(--bg-secondary)]">
      {/* Decorative top line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-500/50 to-transparent" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-5">
            <Link to="/" className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full overflow-hidden ring-2 ring-brand-500/30">
                <img src="/images/fivetrader.png" alt="FiveTrader" className="w-full h-full object-cover" />
              </div>
              <span className="text-xl font-bold">
                <span className="gradient-text">Five</span>
                <span className="text-[var(--text-primary)]">Trader</span>
              </span>
            </Link>
            <p className="text-sm text-[var(--text-secondary)] leading-relaxed max-w-xs">
              Empowering investors with expert education on stock market fundamentals, technical analysis, and crypto trading strategies.
            </p>
            <a
              href="mailto:hostinghubx@gmail.com"
              className="inline-flex items-center gap-2 text-sm text-brand-600 dark:text-brand-400 hover:underline"
            >
              <Mail size={14} />
              hostinghubx@gmail.com
            </a>
          </div>

          {/* Platform Links */}
          <div>
            <h4 className="text-sm font-semibold text-[var(--text-primary)] uppercase tracking-wider mb-4">Platform</h4>
            <ul className="space-y-3">
              {footerLinks.Platform.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-[var(--text-secondary)] hover:text-brand-600 dark:hover:text-brand-400 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-sm font-semibold text-[var(--text-primary)] uppercase tracking-wider mb-4">Resources</h4>
            <ul className="space-y-3">
              {footerLinks.Resources.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-[var(--text-secondary)] hover:text-brand-600 dark:hover:text-brand-400 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-sm font-semibold text-[var(--text-primary)] uppercase tracking-wider mb-4">Connect</h4>
            <ul className="space-y-3">
              {footerLinks.Social.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-sm text-[var(--text-secondary)] hover:text-brand-600 dark:hover:text-brand-400 transition-colors"
                  >
                    {link.name}
                    <ExternalLink size={12} />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="mt-12 pt-8 border-t border-[var(--border-color)]">
          <p className="text-xs text-[var(--text-muted)] leading-relaxed text-center max-w-4xl mx-auto">
            <strong>Disclaimer:</strong> The information in my videos, analyses, and writings is solely for educational purposes, not investment advice. I cannot guarantee the accuracy of the information shared, so please consult your financial advisor before making any decisions. I am not SEBI registered.
          </p>
          <p className="text-xs text-[var(--text-muted)] text-center mt-4">
            &copy; {new Date().getFullYear()} FiveTrader. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}
